module.exports = __webpack_public_path__ + "static/media/investing.79dbced2.png";